<script setup lang="ts">
import { NewProductDialog } from '@/types/api/api-v4/product'

import ProductDialogContent from '@/components/Product/ProductDialogContent.vue'

type Props = {
  productDialog: NewProductDialog
}

defineProps<Props>()

const emit = defineEmits(['closeDialogProduct'])

const { isMobile } = useResponsive()

const closeDialogProduct = () => {
  emit('closeDialogProduct')
}
</script>

<template>
  <the-bottom-sheet
    v-if="isMobile"
    :model-value="productDialog.visible"
    padding="0"
    persistent-close
    @update:model-value="closeDialogProduct"
  >
    <product-dialog-content
      v-if="productDialog.currentProduct"
      :product="productDialog.currentProduct"
      :products="productDialog.productList"
      class="product-dialog-content"
    />
  </the-bottom-sheet>

  <the-dialog
    v-if="!isMobile"
    :model-value="productDialog.visible"
    :max-width="789"
    @update:model-value="closeDialogProduct"
  >
    <product-dialog-content
      v-if="productDialog.currentProduct"
      :product="productDialog.currentProduct"
      :products="productDialog.productList"
      class="product-dialog-content"
    />
  </the-dialog>
</template>
